import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {Router} from '@angular/router';
import {
    DataStateChangeEvent,
    ExcelExportEvent,
    GridComponent,
    GridDataResult,
    PageChangeEvent
} from '@progress/kendo-angular-grid';
import {DatePipe} from '@angular/common';
import {orderBy, process} from '@progress/kendo-data-query';
import {OrderItemService} from '~/app/core/common/services/order-item.service';
import {IOrderItemInfo} from '~/app/core/interfaces/mobile/order_Item_info';
import {AuthServicesService} from 'mclane-webauth-lib';
import {ItemService} from '~/app/core/common/services/item.service';
import {OrderItemInsert} from '~/app/core/common/models/orderItemInsert';
import {OrderItemArray} from '~/app/core/common/models/orderItemArray';
import {OrderService} from '~/app/core/common/services/order.service';
import {MatDialog} from '@angular/material/dialog';
import {Subject, Subscription, timer} from 'rxjs';
import {environment} from '~/environments/environment';
import {NotificationService} from '@progress/kendo-angular-notification';
import {AppEnums, AppEnumsSession} from '~/app/web/AppProvider/AppEnums';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {ToastrService} from 'ngx-toastr';
import {ConnectionService} from 'ng-connection-service';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import {OrderScheduleStatus} from '~/app/core/common/enums/OrderScheduleStatus';
import {GlobalMessageBoxService} from '~/app/web/global-message-box.service';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {ReportService} from '~/app/core/common/services/report.service';
import {Nomenclatures} from '~/app/core/common/enums/Nomenclatures';
import {CustomerCategory} from '~/app/core/common/models/customerCategory';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';
import {DialogHelperComponent, DialogType} from '~/app/shared/helpers/dialog-helper';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {OrderItem} from '~/app/core/common/models/orderItem';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {ScheduleService} from '~/app/core/common/services/schedule.service';
import {ExcelExportData} from '@progress/kendo-angular-excel-export';
import {OrderUploadComponent} from '~/app/web/order-upload/order-upload.component';
import {DialogCloseResult, DialogService} from '@progress/kendo-angular-dialog';
import {OrderUploadMessageComponent} from '~/app/order-upload-message/order-upload-message.component';
import {GlobalErrorHandlerService} from '~/app/shared/services/globalErrorHandlerService';
import {SplunkMessage} from '~/app/core/common/models/splunkMessage';
import {ComponentCanDeactivate} from "~/app/shared/navigation/component-can-deactivate";
import { ToastService } from '~/app/shared/helpers/toast-service';
import {fileExcelIcon, filePdfIcon,undoIcon, uploadIcon,trackChangesAcceptAllIcon,cancelIcon, saveIcon, eyeIcon, SVGIcon} from "@progress/kendo-svg-icons";
@Component({
    selector: 'app-ordering',
    templateUrl: './ordering.component.html',
    styleUrls: ['./ordering.component.scss'],
    providers: [NotificationService]
})
export class OrderingComponent extends ComponentCanDeactivate implements OnInit, OnDestroy {

    @ViewChild('container', {static: false, read: ViewContainerRef})
    public container: ViewContainerRef;
    // tslint:disable-next-line:max-line-length
    public columns: any[] = [
        {field: 'description', title: Nomenclatures.DESCRIPTION, width: '240', filterable: true},
        {field: 'unitOfMeasure', title: Nomenclatures.UNIT_OF_MEASURE, width: '150', filterable: false},
        {
            field: 'daysSinceLast',
            title: Nomenclatures.DAYS_SINCE_LAST_ORDERED,
            width: '165',
            media: '(min-width: 768px)'
        },
        /* {field: 'qtyLastOrdered', title: Nomenclatures.QUANTITY_LAST_ORDERED, width: '150', media: '(min-width: 768px)'},
         {field: 'qtySuggested', title: Nomenclatures.SUGGESTED_QUANTITY, width: '150', media: '(min-width: 768px)'},*/
        {field: 'perCost', title: Nomenclatures.COST, width: '100', format: '{0:c}'}];
    public storeChangable = false;
    public hasValueChanged = false;
    public hasFieldBeenClicked = false;
    public value: any = [];
    public textBoxValue: any = [];
    selectedCategories: any[] = [];
    public selection: string[] = [];
    public totalPrice = 0.00;
    public itemInsert = new OrderItemInsert();
    @Output() itemInsertOutput = new EventEmitter<OrderItemInsert>();
    public changedItems: OrderItemArray[] = [];
    public alreadyCreated = false;
    public state: DataStateChangeEvent = {
        skip: 0,
        take: 60,
        filter: {
            logic: "or",
            filters: [],
          }
    };
    public gridData: GridDataResult = null;
    public loading = false;
    totalItemsOrdered = 0;
    // trackingId: string;
    status:any = true;
    searchText: any;
    public _buttonStatus: boolean;
    public _buttonStatusUpload: boolean;
    public _processRunning: boolean;
    Nomenclatures = Nomenclatures;
    isCartEnabled: boolean;
    @ViewChild(GridComponent, {static: true})
    orderingGrid: GridComponent;
    public hiddenColumns: string[] = [Nomenclatures.qtyLastOrdered];
    public qtyButtonText: String = Nomenclatures.QUANTITY_LAST_ORDERED_SHORT;
    public qtyButtonBool: Boolean;
    selectedRow: Array<any> = [];
    public submitProcessing = false;
    parentSubject: Subject<any> = new Subject();
    public today: number;
    public _criticalItemCheck: number = 0;
    public _reviewOrderButtonHidden: boolean = false;
    public _returnToOrderButtonHidden: boolean = true;
    public _submitOrderButtonHidden: boolean = true;
    public _cancelOrderButtonHidden: boolean = false;
    public _copyOrderButtonHidden: boolean = false;
    public _lastQtyOrderButtonHidden: boolean = false;
    public showCategories: boolean = true;
    public trackingId: any;
    public trackingIdFromDatabase: any;
    private orderItems: OrderItem[] = [];
    private dbTimer: Subscription;
    private searchableItems: OrderItem[];
    private _orderStatus: string;
    private _cartClicked: boolean;
    private _categoryChangeListener: boolean;
    public filePdfIcon: SVGIcon = filePdfIcon;
    public fileExcelIcon: SVGIcon = fileExcelIcon;
    public saveIcon: SVGIcon =saveIcon;
    public undoIcon:SVGIcon = undoIcon;
    public trackAllchanges: SVGIcon= trackChangesAcceptAllIcon;
    public uploadIcon: SVGIcon = uploadIcon;
    public cancelIcon:SVGIcon = cancelIcon;
    public eyeIcon : SVGIcon = eyeIcon;

    constructor(private _authServices: AuthServicesService,
                private _orderItemService: OrderItemService,
                private _router: Router,
                private _ref: ChangeDetectorRef,
                private _itemsService: ItemService,
                private _configurationService: ConfigurationService,
                private _storeListService: StoreListService,
                private _orderService: OrderService,
                private _reportService: ReportService,
                private _dialog: MatDialog,
                private _localStore: LocalStorageIndexedService,
                private _toaster: ToastrService,
                private _scheduleService: ScheduleService,
                private _connectionService: ConnectionService,
                private _messageBox: GlobalMessageBoxService,
                private _globalError: GlobalErrorHandlerService,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
                private _profileCategoriesService: ProfileCategoriesService,
                private _datePipe: DatePipe,
                public dialogHelper: DialogHelperComponent,
                public applicationSettings: ApplicationSettingsHelper,
                private dialogService: DialogService,
                private toaster:ToastService
    ) {
        super();
        this.exportAllData = this.exportAllData.bind(this);
        this._categoryChangeListener = true;
        this._connectionService.monitor().toPromise().then((connected) => {
            this.status = connected;
        });

        if (this.applicationSettings.getFileUpload() === 'N') {
            this._buttonStatusUpload = true;
        } else {
            this._buttonStatusUpload = false;
        }
    }

    // Standard ngOnInit but also has item downloader
    async ngOnInit() {

        this.today = Date.now();
        this.StartOrderTimerDB(environment.timerAutoSaveDB);

        await this.getTrackingIdFromDatabase();

        if (+this.applicationSettings.getTrackingId() > 0 && this.applicationSettings.getTrackingId() != '') {
            console.error('set from local storage');
            this.trackingId = this.applicationSettings.getTrackingId();
            this.alreadyCreated = true;
        } else if (await this.trackingIdFromDatabase != null) {
            console.error('set from databse');
            this.trackingId = await this.trackingIdFromDatabase;
        } else {
            console.error('cannot be set, sending home');
            this._router.navigate(['/home']).then();
        }


        if (this.trackingIdFromDatabase > 0 && this.trackingIdFromDatabase < this.trackingId) {
            return await this.dialogHelper.open(
                {
                    type: DialogType.INFO,
                    title: 'Invalid PO Number ' + this.trackingId,
                    content: 'Our records indicate you have an open order with PO Number ' + this.trackingIdFromDatabase + '. Please complete this order and try again. ',
                    actions: [
                        {text: 'Ok', themeColor:"primary"}
                    ],
                    width: 400
                }).then(results => {
                this.applicationSettings.setTrackingId('');
                this.loading = false;
                this._router.navigate(['/home']);
            });

        }

        if (this._profileCategoriesService.customerCategories === undefined) {
            this._profileCategoriesService.getCustomerCategories().then(r => r);
        }
        await this.saveOrderGuide();
    }


    async getTrackingIdFromDatabase() {
        this.trackingIdFromDatabase = await this._orderService.checkOpenOrder(
            this._storeListService.pickedCustomerId)
            .toPromise().then().catch((error) => {
                this.errorCatch(error);
                return error;
            })
            .then((trackingId: any) => {
                if (trackingId === null) {
                    console.error('Problem Making calls to the service');
                    return '0';
                } else {
                    return trackingId;
                }
            });

    }

    canDeactivate(): boolean {
        this.applicationSettings.setTrackingId('');
        return !this.hasFieldBeenClicked;
    }

    // Gets called every time a record is changed

    startProcessRunning() {
        this._loadingIndicatorHelper.show('');
        this._processRunning = true;
        this._buttonStatus = true;
    }

    stopProcessRunning() {
        this._processRunning = false;
        this._buttonStatus = false;
        this.hasFieldBeenClicked = false;
        this._loadingIndicatorHelper.hide();
    }

    startProcessSaveRunning() {
        this.showNotificationWarning(Nomenclatures.TOAST_ORDER_SAVING, 3000);
        this._processRunning = true;
        this._buttonStatus = true;
        this.hasFieldBeenClicked = false;
    }

    stopProcessSaveRunning() {
        this._processRunning = false;
        this._buttonStatus = false;
    }

    ngOnDestroy(): void {
        this.dbTimer.unsubscribe();
        this.applicationSettings.setEvent('');
        this.applicationSettings.setTrackingId('');
    }

    public async saveOrderGuide() {
        this.loading = true;

        const selectedStore = this._storeListService.pickedStore;
        if (selectedStore == null
            || this.trackingId === null
            || this.trackingId == undefined
            || this.trackingId === '') {
            this._router.navigateByUrl('/').catch().then(() => {
                this.applicationSettings.setTrackingId('');
            });
            return;
        }
        this._orderStatus = this._configurationService.getOrderStatus();
        const pickedCustomerId = await this._storeListService.pickedCustomerIdVerify();
        this._orderItemService.downloadAllItemsByStoreNumber(pickedCustomerId.toString(), this.trackingId)
            .then((items: any) => {
                this.orderItems = items;
                this.orderItems = this.orderItems.filter((item) => {
                    if (item.showIndicator !== true) {
                        if (item.quantity > 0) {
                            return item;
                        }
                    } else if (item.activeFlag !== 'I') {
                        return item;
                    }
                });
                this.orderItems = this.sortProfileItems(this.orderItems);
                this.itemInsert.trackingId = +this.trackingId;
                this.itemInsert.custId = pickedCustomerId.toString();
                this.prepareItems();
                this.createCategoriesandLoadTable();

                this._profileCategoriesService.selectedCategory = this._profileCategoriesService.customerCategories.find(category => category.description === 'ALL ITEMS');

                if (this._orderStatus === OrderScheduleStatus.STARTED.toString()) {
                    this.isCartEnabled = false;
                    this._profileCategoriesService.selectedCategory.selected = true;
                } else {
                    this.isCartEnabled = false;
                    this._profileCategoriesService.selectedCategory.selected = true; // TODO set to all items? or last selected cat?
                }
                this.categoryChanged();
            });
        this.hasFieldBeenClicked = false;
    }

    public restartState() {
        this.state.skip = 0;
    }

    public createCategoriesandLoadTable() {
        this.restartState();
        this.gridData = process(this.hideItemsfromList(this.orderItems), this.state);
        this._ref.detectChanges();
        this.loading = false;
    }

    // When the Filter is changed on the grid itself
    public dataStateChange(state: DataStateChangeEvent) {
        this.state = state;
        // this.restartState();
        if (this.searchableItems === null) {
            const itemsCount = this.orderItems.length;
            this.gridData = process(this.orderItems, this.state);
            this.gridData.total = itemsCount;
        } else {
            this.gridData.total = this.searchableItems.length;
            this.gridData = process(this.searchableItems, this.state);
        }
        this._ref.detectChanges();
    }

    getItem(dataItem: IOrderItemInfo) {
        return this.orderItems.find((item) => item.itemNo === dataItem.itemNo);
    }

    // Checks if the record is over a certain record
    quantityChanged(dataItem: IOrderItemInfo) {
        this.hasFieldBeenClicked = true;
        dataItem.quantity = +dataItem.quantity;
        const tempItem = this.getItem(dataItem);
        if (dataItem.quantity === 0) {
            tempItem.updated = true;
            dataItem.updated = true;
            dataItem.quantity = 0;
            dataItem.price = dataItem.quantity * dataItem.perCost;
            this.hasValueChanged = true;
            this.sumItem();
            this.getTotalitems();
        } else if (dataItem.quantity && dataItem.quantity.toString().trim()) {
            if (dataItem.quantity > -1 && dataItem.quantity < 1000) {
                if (dataItem.quantity > dataItem.maxQuantity) {
                    this.showNotification(Nomenclatures.TOAST_MAX_QUANTITY, 8000);
                    dataItem.updated = true;
                    tempItem.updated = true;
                    dataItem.price = dataItem.quantity * dataItem.perCost;
                    this.sumItem();
                    this.getTotalitems();
                } else {
                    dataItem.updated = true;
                    tempItem.updated = true;
                    dataItem.price = dataItem.quantity * dataItem.perCost;
                    this.sumItem();
                    this.getTotalitems();
                }

                // TODO don't show if 10% and quantity entered not same as last qty
                const regexp = new RegExp('\\b(\\d)\\1+\\b');
                const regEx = regexp.test(dataItem.quantity.toString());
                if (regEx) {
                    this.showNotification(Nomenclatures.TOAST_INVALID_QUANTITY, 8000);
                    dataItem.price = dataItem.quantity * dataItem.perCost;
                    dataItem.updated = true;
                    tempItem.updated = true;
                    this.sumItem();
                    this.getTotalitems();
                }
                dataItem.updated = true;
                tempItem.updated = true;
                this.hasValueChanged = true;
                this.saveOrdertoLocalStore();
            } else if (isNaN(dataItem.quantity)) {
                this.showNotification(
                    Nomenclatures.TOAST_INVALID_ENTRY + ' (' + dataItem.quantity + '), ' + Nomenclatures.TOAST_INVALID_NUMBER_TYPE, 3000);
                dataItem.quantity = 0;
                dataItem.price = dataItem.quantity * dataItem.perCost;
                this.sumItem();
                this.getTotalitems();
            } else {
                this.showNotification(
                    Nomenclatures.TOAST_INVALID_ENTRY + ' (' + dataItem.quantity + '), ' + Nomenclatures.TOAST_INVALID_NUMBER_AMOUNT, 3000);
                dataItem.quantity = 0;
                dataItem.price = dataItem.quantity * dataItem.perCost;
                this.sumItem();
                this.getTotalitems();
            }
        } else {
            dataItem.quantity = 0;
            dataItem.price = dataItem.quantity * dataItem.perCost;
            this.sumItem();
            this.getTotalitems();
        }
    }

    // If loading previous saved order
    prepareItems() {
        this.orderItems.forEach((value) => {
            value.price = value.quantity * value.perCost;
        });
        this.sumItem();
        this.getTotalitems();
    }

    // Handles Page Change Event
    pageChange($event: PageChangeEvent) {
        this.state.skip = $event.skip;
        this.state.take = $event.take;
        this.dataStateChange(this.state);
    }

    // Sums Items
    sumItem() {
        const numbers = this.orderItems.map(i => i.price);
        this.totalPrice = numbers.reduce((a, b) => a + b, 0);
    }

    // Gets total items
    getTotalitems() {
        const numbers = this.orderItems.map(i => +i.quantity);
        if (numbers.length > 0) {// TODO is this the
            this.totalItemsOrdered = numbers.reduce((a, b) => a + b);
            this._localStore.setToSession(AppEnumsSession.cartCount, this.totalItemsOrdered);
            this.orderItems.filter(item => item.quantity > 0);
        }


    }


    async orderAlreadySubmitted() {
        return await this.dialogHelper.open(
            {
                type: DialogType.INFO,
                title: Nomenclatures.ORDER_ALREADY_SUBMITTED_TITLE,
                content: Nomenclatures.ORDER_ALREADY_SUBMITTED,
                actions: [
                    {text: 'Ok', themeColor:"primary"}
                ],
                width: 400
            }).then(async results => {

        }).then(async () => {
            this.applicationSettings.setTrackingId('');
            this.loading = false;
            await this._router.navigate(['/home']);

        });
    }

    // Saves item to localstorage
    async submitOrder() {

        this.startProcessRunning();
        try {
            const itemQty = this.orderItems.filter(item => item.quantity);
            if (itemQty.length > 0) {
                const orderStatus = await this.createOrderStatus();
                if (orderStatus == null) {
                    this.toaster.showToastError('There was a problem creating this order', 'Error', 1000);
                    return false;
                }
                // tslint:disable-next-line:triple-equals
                if (orderStatus !== '0') {
                    if (this.checkForCaseAllocationExceeds()) {
                        this.orderExceedsCaseAllocation();
                        this.stopProcessRunning();
                        return false;
                    } else {
                        var count = 0;
                        this.orderItems.find((item) => {
                            if (item.showIndicator !== true && item.activeFlag !== 'I') {
                                if (item.quantity > 0) {
                                    count++;
                                }
                            }
                        });

                        const critItemtOrdered = this.orderItems.filter((item) => item.critical === true && item.quantity !== 0);
                        const y = this.orderItems.filter((item) => item.critical === true);

                        await this.dialogHelper.open(
                            {
                                type: DialogType.INFO,
                                title: 'Submit Order',
                                content:

                                    count + " hidden item(s) on order." +
                                    "\n" +
                                    critItemtOrdered.length + ' of ' + y.length + " critical item(s) on order." +
                                    "\n\n" +
                                    "Are you sure you want to submit your order?"

                                ,
                                actions: [
                                    {text: 'No'},
                                    {text: 'Yes', themeColor:"primary"}
                                ],
                                width: 400
                            }).then(results => {
                            if (results === 'Yes') {
                                this.saveItemsForComplete(this.trackingId).catch(error => {
                                    this.errorCatch(error);
                                });
                            }
                        });
                    }
                }
            } else {
                await this.dialogHelper.open(
                    {
                        type: DialogType.WARNING,
                        title: Nomenclatures.DIALOG_ORDER_NOT_SUBMITTED_TITLE,
                        content: Nomenclatures.DIALOG_ORDER_NOT_SUBMITTED_MESSAGE,
                        actions: [
                            {text: 'Ok', themeColor:"primary"}
                        ],
                        width: 400
                    });
            }
        } catch (exception) {
            this.stopProcessRunning();
            throw(exception);
        } finally {
            this.stopProcessRunning();
        }
    }


    async saveItemsForComplete(trackingId: string) {
        this.startProcessRunning();
        this.changedItems = [];
        this.orderItems.forEach(dataItem => {
            const itemsArray = new OrderItemArray();
            itemsArray.itemNo = dataItem.itemNo.toString();
            itemsArray.quantity = dataItem.quantity;
            this.changedItems.push(itemsArray);
        });
        this.itemInsert.orderItems = this.changedItems;
        const itemsResult = await this.insertItemsIntoTable().catch(async error => {
            this.errorCatch(error);
        });
        if (itemsResult) {
            this.itemInsert.orderItems = [];
            const orderStatus = await this.setOrderStatus(trackingId, +OrderScheduleStatus.PLACED, this.itemInsert.custId).catch(async error => {
                this.errorCatch(error);
            });
            if (orderStatus) {
                this.stopProcessRunning();
                await this.finishOrder();
            }
        } else {
            // this._messageBox.ErrorPageAlert(Nomenclatures.DIALOG_ORDER_ITEM_INSERT_ERROR_MESSAGE).then(r => r);
            console.error(itemsResult);
        }
        this.stopProcessRunning();
        return;
    }

    errorCatch(error: any) {
        const display = 'SPL.ID: ' + error.traceid.toUpperCase();
        this.dialogHelper.open(
            {
                type: DialogType.ERROR,
                title: 'Error for Order - ' + this.trackingId,
                content: error.message + '\n' + '\n' + display,
                actions: [
                    {text: 'Ok', themeColor:"primary"}
                ],
                width: 400
            }).then(results => {
            this.applicationSettings.setTrackingId('');
            this.loading = false;
            this._router.navigate(['/home']);
        });
    }

    async setOrderStatus(trackingId: string, status: number, custId: string) {
        return await this._orderService
            .setStatusOrder(trackingId, status, custId).toPromise().catch((error) => {
                this.errorCatch(error);
                // this._messageBox.ErrorPageAlert(Nomenclatures.DIALOG_ORDER_STATUS_ERROR_MESSAGE).then(r => r);
                console.error(error);
                return false;
            }).then((result) => true);
    }

    async finishOrder() {
        this.dbTimer.unsubscribe();
        this.itemInsert.orderItems = [];
        this.alreadyCreated = false;
        await this.dialogHelper.open(
            {
                type: DialogType.INFO,
                title: Nomenclatures.PURCHASE_ORDER + `: ${this.trackingId}`,
                content: Nomenclatures.DIALOG_ORDER_PLACED_MESSAGE,
                actions: [
                    {text: 'Ok', themeColor:"primary"}
                ],
                width: 400
            }).then(async results => {
            if (results === 'Ok') {
                await this._router.navigateByUrl('/').then(() => {
                    this.applicationSettings.setTrackingId('');
                    this.applicationSettings.setEvent('');
                });
            }
        });
    }

    filterItemsByCategory() {
        const itemArray = [];
        this.orderItems.map((value) => {
            const categories = value.itemCategories;
            if (categories != null) {
                const selectedCategory = this._profileCategoriesService.selectedCategory;
                const valueExists = this.checkCategoryExists([this._profileCategoriesService.selectedCategory.description], categories.map(cat => cat.categoryName));
                if (valueExists) {

                    const itemsequence = categories.find((item) => {
                        return item.categoryName === selectedCategory.description;
                    }).sequence;
                    value.sequence = itemsequence;
                    itemArray.push(value);
                }
            }

        });
        return itemArray;
    }

    categoryClicked(customerCategory: CustomerCategory) {

        if (this._categoryChangeListener) {
            if (customerCategory === null) {
                return;
            }
            if (this.isCartEnabled || this._cartClicked) {
                this.isCartEnabled = false;
            }
            this.categoryChanged();
            this._ref.detectChanges();
            this._cartClicked = false;

            this._submitOrderButtonHidden = true;
            this._reviewOrderButtonHidden = false;
            this._returnToOrderButtonHidden = true;
        }
    }

    // Mainly being called from the chip changed method it searches and prepares new list of items
    categoryChanged() {
        this.restartState();
        this.state.skip = 0;
        this.selectedRow = [];
        const items = this.filterItemsByCategory();
        const sortedItems = this.sortProfileItems(items);
        this.gridData = process(sortedItems, this.state);
        this.searchableItems = sortedItems;
        this._ref.detectChanges();
    }

    resetCategoriesToEmpty() {
        this._profileCategoriesService.customerCategories.forEach(category => {
            category.selected = false;
        });
    }

    checkIfExists(items: OrderItem[]): OrderItem[] {
        const itemArray = [];
        items.map((value) => {
            const categories = value.itemCategories;
            if (categories != null) {
                const selectedCategory = this.selectedCategories[0];
                const valueExists = this.checkCategoryExists(this.selectedCategories.map(cat => cat.value), categories.map(cat => cat.categoryName));
                if (valueExists) {

                    const itemsequ = categories.find((item) => {
                        return item.categoryName === selectedCategory.value;
                    }).sequence;
                    value.sequence = itemsequ;
                    itemArray.push(value);
                }
            }

        });
        return itemArray;
    }

    // if value is greater than 0 it means the item is "ORDERED" or in the cart
    checkIfOrdered(items: OrderItem[]): OrderItem[] {
        const itemArray = [];
        items.map((value) => {
            if (value.quantity > 0) {
                itemArray.push(value);
            }
        });
        return itemArray;
    }

    // Checking if Category exists in item
    checkCategoryExists(selectedCategories, itemCategories): boolean {

        return itemCategories.some(function (v) {
            return selectedCategories.indexOf(v) >= 0;
        });
    }

    // Search on the value of the main item list
    textboxChanged(newValue) {
        this.textBoxValue = newValue;
        this.selectedRow = [];
        const result = this.searchItems(newValue, this.searchableItems);
        this.state.skip = 0;
        this.gridData = process(result, this.state);
    }

    // Search items from whole list
    searchItems(stringValue: string, array: OrderItem[]): OrderItem[] {
        return array.filter(el => el.description.toLowerCase().indexOf(stringValue.toLowerCase())
            !== -1 || el.itemNo.toString().indexOf(stringValue) !== -1);
    }

    quantityFocused(id: string) {
        this.hasFieldBeenClicked = true;
        this.selection = [];
        this.selection.push(id);
    }

    hideItemsfromList(items: OrderItem[]): OrderItem[] {
        return items;
        //.filter(x => x.showIndicator);

    }

    async insertItemsIntoTable() {
        return await this._orderService.insertItemsIntoOrder(this.itemInsert).toPromise();
    }

    async saveOrder(fullSave: boolean = false) {

        try {

            if (!this.hasValueChanged) {
                this.showNotification('No changes detected.', 2000);
                return;
            }
            if (!this.status) {
            }
            const itemsUpdated = this.orderItems.filter(item => item.updated === true);
            const itemQty = this.orderItems.filter(item => item.quantity > 0);
            if (itemQty.length > 0) {
                this.startProcessSaveRunning();
                this.changedItems = [];
                itemsUpdated.forEach(dataItem => {
                    const itemsArray = new OrderItemArray();
                    itemsArray.itemNo = dataItem.itemNo.toString();
                    itemsArray.quantity = dataItem.quantity;
                    this.changedItems.push(itemsArray);
                });
                this.itemInsert.orderItems = this.changedItems;
                let orderStatus = null;
                if (!this.alreadyCreated) {
                    orderStatus = await this.createOrderStatus();
                    this.alreadyCreated = true;
                } else {
                    orderStatus = this.trackingId;

                }
                if (orderStatus == null) {
                    this.stopProcessSaveRunning();
                    throw new Error('Could not create the order');
                }

                this.trackingId = orderStatus;
                // this.applicationSettings.setTrackingId(orderStatus);
                const itemsResult = await this.insertItemsIntoTable().catch(async error => {
                    this.errorCatch(error);
                });
                if (itemsResult) {
                    const orderStatusResult = await this.setOrderStatus(this.trackingId, +OrderScheduleStatus.STARTED, this.itemInsert.custId).catch(async error => {
                        this.errorCatch(error);
                    });

                    if (!orderStatusResult) {
                        return null;
                    }

                    if (fullSave) {
                        this.stopProcessSaveRunning();
                        await this.dialogHelper.open({
                            type: DialogType.INFO,
                            title: Nomenclatures.DIALOG_ORDER_SAVED_TITLE,
                            content: Nomenclatures.DIALOG_ORDER_SAVED_MESSAGE,
                            actions: [
                                {text: 'Ok', themeColor:"primary"}
                            ],
                            width: 400
                        });
                        this.orderItems.map((item) => {
                            item.updated = false;
                        });
                    } else {
                        this.orderItems.map((item) => {
                            item.updated = false;
                        });
                        this.stopProcessSaveRunning();
                        this.hasValueChanged = false;
                        this.showNotification(Nomenclatures.TOAST_ORDER_SAVED, 5000);
                        this.hasFieldBeenClicked = false;
                    }
                }
            } else {
                await this.dialogHelper.open(
                    {
                        type: DialogType.WARNING,
                        title: Nomenclatures.DIALOG_ORDER_NOT_SAVED_TITLE,
                        content: Nomenclatures.DIALOG_ORDER_NOT_SAVED_MESSAGE,
                        actions: [
                            {text: 'Ok', themeColor:"primary"}
                        ],
                        width: 400
                    });
            }
        } catch (error) {
            this.stopProcessSaveRunning();
            throw(error);
        }
    }

    async copyOrder() {
        const copyOrderMessage = Nomenclatures.DIALOG_COPY_ORDER_MESSAGE;
        await this.dialogHelper.open(
            {
                type: DialogType.WARNING,
                title: Nomenclatures.DIALOG_COPY_ORDER_TITLE,
                content: copyOrderMessage,
                actions: [
                    {text: 'No'},
                    {text: 'Yes', themeColor:"primary"}
                ],
                width: 600
            }).then(results => {
            if (results === 'Yes') {
                this.orderItems.forEach((value) => {
                    if (value.qtySuggested >= 0) {
                        value.updated = true;
                        value.quantity = value.qtySuggested;
                        value.price = value.quantity * value.perCost;
                    }
                });
                this.sumItem();
                this.getTotalitems();
                this.hasValueChanged = true;
            }
        });
    }

    checkIfCriticalItemsSelected() {
        const x = this.orderItems.filter((item) => item.critical === true && item.quantity === 0);
        return x.length > 0;
    }

    saveOrdertoLocalStore() {
        this._localStore.setToStorage(AppEnums.SavedOrder, this.orderItems).toPromise().then(() => {
            console.log('Items Saved');
        });
    }

    public exportAllData(): ExcelExportData {

        /** Export Grid Data for Cart */ 
        let cartDataToExport: any[] = [];

        /** Check if gridData is an array or an object with a data property */ 
        if (Array.isArray(this.gridData)) {
            cartDataToExport = this.gridData;
        } else if (this.gridData && Array.isArray(this.gridData.data)) {
            cartDataToExport = this.gridData.data;
        }
        if (this.isCartEnabled) {
            return {
                data: cartDataToExport,
        };
        }
        else{
        const items = this.filterItemsByCategory();
        const sortedItems = this.sortProfileItems(items);

        /** Below code check if the gird data is filtered or not */
        const hasFilters = this.state.filter && this.state.filter.filters && this.state.filter.filters.length > 0;

        const result: ExcelExportData = {
            data:hasFilters ? process(sortedItems, this.state).data : sortedItems,
        };
        return result;
    }
}

    public returnObject(args: any) {
        return null;
    }

    public onCartFilter(clicked: boolean) {
        this._categoryChangeListener = false;
        if (clicked) {
            this._cartClicked = true;
            this.isCartEnabled = true;
        }

        if (this.isCartEnabled) {
            this._profileCategoriesService.selectedCategory.selected = false;
            this.resetCategoriesToEmpty();
            this.categoryChanged();
            const items = this.checkIfOrdered(this.orderItems);
            this.gridData = process(items, this.state);
            this.searchableItems = items;
        } else {
            this._profileCategoriesService.customerCategories.forEach(category => {
                if (category.description === ' ALL ITEMS') {
                    category.selected = true;
                    this._profileCategoriesService.selectedCategory = category;
                } else {
                    category.selected = false;
                }
            });
            this.categoryChanged();
            const items = this.checkIfExists(this.orderItems);
            this.gridData = process(items, this.state);
            this.searchableItems = items;
        }
        this._categoryChangeListener = true;
        this.restartState();
        this.gridData.total = this.searchableItems.length;
    }

    async navigate() {
        await this.dialogHelper.open(
            {
                type: DialogType.INFO,
                title: Nomenclatures.DIALOG_EXIT_ORDER_TITLE,
                content: Nomenclatures.DIALOG_EXIT_ORDER_MESSAGE,
                actions: [
                    {text: 'Exit'},
                    {text: 'Save and Exit', themeColor:"primary"}
                ],
                width: 400
            }).then(async results => {
            if (results === 'Save and Exit') {
                const itemQty = this.orderItems.filter(item => item.quantity > 0);
                if (itemQty.length > 0) {
                    this.saveOrder().then(response => {
                        this._router.navigateByUrl('/').catch().then(
                            () => {
                                this.applicationSettings.setTrackingId('');
                            });
                    });
                } else {
                    await this.dialogHelper.open(
                        {
                            type: DialogType.WARNING,
                            title: Nomenclatures.DIALOG_ORDER_NOT_SAVED_TITLE,
                            content: Nomenclatures.DIALOG_ORDER_NOT_SAVED_MESSAGE,
                            actions: [
                                {text: 'Ok', themeColor:"primary"}
                            ],
                            width: 400
                        });
                }
            } else {
                this._router.navigateByUrl('/').catch().then(() => {
                    this.applicationSettings.setTrackingId('');
                });
            }
        });
    }

    async createUnscheduledOrder(): Promise<boolean> {
        const pickedCustomerId = await this._storeListService.pickedCustomerIdVerify();
        return await this._orderService.createUnscheduledOrder(
            pickedCustomerId.toString()).toPromise().then(trackingId => {
            this.trackingId = trackingId;
            this.itemInsert.trackingId = +this.trackingId;
            console.log('Got Unscheduled Tracking ID: ' + trackingId);
            return trackingId;

        }).catch((error) => {
            this.errorCatch(error);
            return error;
        });
    }


    async createScheduledOrder(): Promise<boolean> {
        return this._orderService.createScheduledOrder(this.trackingId,
            this._storeListService.pickedCustomerId)
            .toPromise().then().catch(async (error) => {
                this.stopProcessSaveRunning();
                this.errorCatch(error);
                return '0';
            })
            .then((order: any) => {
                if (order === null) {
                    return '0';
                } else {
                    console.log('Got Scheduled Tracking ID: ' + order);
                    return order;
                }
            });
    }

    async createOrderStatus(): Promise<any> {
        this.checkTrackingId();
        let order;
        if (+this.trackingId === 0 || this.trackingId === null) {
            order = await this.createUnscheduledOrder();
            if (order === '0') {
                return null;
            }
        } else {
            order = await this.createScheduledOrder();
            if (order === '0' && this.trackingId === 0 || this.trackingId === null || this.trackingId === undefined) {
                order = await this.createUnscheduledOrder();
                if (order != null || order != '') {
                    const alt = new SplunkMessage();
                    const error = new Error(``);
                    error.name = 'Orders Already Submitted';
                    error.stack = ` There was a problem creating the order so we created unscheduled order: ${order}`;
                    alt.splid = 'HeadlessOrder';
                    alt.message = error.stack as any;
                    //await this._globalError.generateSplunkId(alt).toPromise().then();
                }
            } else {
                const trackingId = order.trackingId;
                order = order.trackingId;
                this.trackingId = trackingId;
            }
        }
        return order;
    }

    checkTrackingId() {
        if (this.trackingId === undefined) {
            this.trackingId = 0;
        }
    }

    sortProfileItems(items: OrderItem[]) {
        return orderBy(items, [{field: 'sequence', dir: 'asc'}]);
    }

    lastQtyOrSuggested(qtyButtonBool: Boolean) {
        const hiddenColumns = this.hiddenColumns;
        this.qtyButtonBool = qtyButtonBool;
        this.qtyButtonBool = !this.qtyButtonBool;
        if (this.qtyButtonBool) {
            this.qtyButtonText = Nomenclatures.Suggested;
            hiddenColumns.push(Nomenclatures.qtySuggested);
            hiddenColumns.splice(hiddenColumns.indexOf(Nomenclatures.qtyLastOrdered), 1);
        } else {
            this.qtyButtonText = Nomenclatures.QUANTITY_LAST_ORDERED_SHORT;
            hiddenColumns.push(Nomenclatures.qtyLastOrdered);
            hiddenColumns.splice(hiddenColumns.indexOf(Nomenclatures.qtySuggested), 1);
        }
    }

    public isHidden(columnName: string): boolean {
        return this.hiddenColumns.indexOf(columnName) > -1;
    }

    setSelectedNone() {
        this._profileCategoriesService.customerCategories[0].selected = true;
    }

    inputClicked($event: MouseEvent) {
        this.parentSubject.next($event);
    }

    exportToPDF(orderingGrid: GridComponent) {
        this.selectedRow = [];
        try {
            this.loading = true;
            setTimeout(() => {
                orderingGrid.saveAsPDF();
                this.loading = false;
            }, 100);
        } catch (ex) {
            this.dialogHelper.showConfirmDialogOkOnly('Problem', 'There was a problem exporting this worksheet, please try again later').then();
            this.loading = false;
        }
    }

    exportToExcel(orderingGrid: GridComponent) {
        this.selectedRow = [];
        try {
            this.loading = true;
            setTimeout(() => {
                orderingGrid.saveAsExcel();

                this.loading = false;
            }, 100);
        } catch (ex) {
            this.dialogHelper.showConfirmDialogOkOnly('Problem', 'There was a problem exporting this worksheet, please try again later').then();
            this.loading = false;
        }
    }

    excelExported($event: ExcelExportEvent) {
        const sheet = $event.workbook.sheets[0];
        sheet.freezePane.rowSplit = 0;
        sheet.rows.unshift({
            cells: [
                {value: 'SourceLink - Order Work Sheet', fontSize: 20, colSpan: 4}
            ]
        }, {
            cells: [
                {value: `Store: ${this._storeListService.pickedIdentity}`, fontSize: 20, colSpan: 4}
            ]
        });
        sheet.name = 'Ordering Worksheet';
    }

    checkForCaseAllocationExceeds() {
        if (this._storeListService.pickedStore == null) {
            return false;
        }
        const alloc = this._storeListService.pickedStore.caseAlloc;
        return this.totalItemsOrdered > alloc;
    }

    orderExceedsCaseAllocation() {
        if (this._storeListService.pickedStore == null) {
            return false;
        }
        const alloc = this._storeListService.pickedStore.caseAlloc;
        const count = this.totalItemsOrdered - alloc;
        const message = `The total items of your order exceeds the maximum case count. Please reduce your order count by ${count}`;
        this.dialogHelper.showConfirmDialogOkOnly('Warning', message).then(r => r);
    }

    uploadOrder() {
        this.itemInsertOutput.emit(this.itemInsert);
        this.dialogHelper.open(
            {
                type: DialogType.WARNING,
                title: 'Warning',
                content: OrderUploadMessageComponent,
                actions: [
                    {text: 'Cancel'},
                    {text: 'Ok', themeColor:"primary"}
                ],
                width: 400
            }).then(async results => {
            if (results === 'Ok') {

                const dialogRef = this.dialogService.open(
                    {
                        title: 'Order Upload',
                        content: OrderUploadComponent,
                        actions: [
                            {text: 'Cancel'},
                            {text: 'Apply', themeColor:"primary"}
                        ],
                        width: 400,
                        height: 400
                    });

                const diaRef = dialogRef.content.instance;
                diaRef.itemInsert = this.itemInsert;
                dialogRef.result.subscribe(async (result) => {
                    if (result instanceof DialogCloseResult) {
                    } else {
                        await this.saveOrderGuide();
                        this.createCategoriesandLoadTable();
                        this.hasValueChanged = true;
                    }
                });
            } else {
                // cancel clicked, do nothing
            }
        });
    }

    async reviewOrder() {

        const itemQty = this.orderItems.filter(item => item.quantity);
        if (itemQty.length > 0) {
            if (this.checkIfCriticalItemsSelected() && this._criticalItemCheck === 0) {
                this._criticalItemCheck = 1;
                const criticalItemMessage = Nomenclatures.DIALOG_CRITICAL_ITEM_DETECTED_MESSAGE_WEB;
                const results = await this.dialogHelper.open(
                    {
                        type: DialogType.WARNING,
                        title: Nomenclatures.DIALOG_CRITICAL_ITEM_WARNING,
                        content: criticalItemMessage,
                        actions: [
                            {text: 'No'},
                            {text: 'Yes', themeColor:"primary"}
                        ],
                        width: 400
                    }).then(results => {
                    if (results === 'Yes') {
                        this._profileCategoriesService.customerCategories.forEach(cat => {
                            if (cat.description === 'CRITICAL ITEMS') {
                                cat.selected = true;
                                this._profileCategoriesService.selectedCategory = cat;
                            } else {
                                cat.selected = false;
                            }
                        });
                        this.categoryChanged();
                        //  this.stopProcessRunning();
                        // they said NO
                    } else {
                        this.showCategories = false;
                        this._submitOrderButtonHidden = false;
                        this._reviewOrderButtonHidden = true;
                        this._returnToOrderButtonHidden = false;
                        this._cancelOrderButtonHidden = true;
                        this._lastQtyOrderButtonHidden = true;
                        this._copyOrderButtonHidden = true;
                        // TODO send to cart view
                        this.onCartFilter(true);
                        // this.saveItemsForComplete(this.trackingIdFromDatabase);
                    }
                });
                return false;
            } else {
                this.showCategories = false;
                this._submitOrderButtonHidden = false;
                this._reviewOrderButtonHidden = true;
                this._returnToOrderButtonHidden = false;
                this._cancelOrderButtonHidden = true;
                this._lastQtyOrderButtonHidden = true;
                this._copyOrderButtonHidden = true;
                this.onCartFilter(true);
            }
        } else {
            await this.dialogHelper.open(
                {
                    type: DialogType.WARNING,
                    title: 'Cart is empty',
                    content: 'Please add items to review',
                    actions: [
                        {text: 'Ok', themeColor:"primary"}
                    ],
                    width: 400
                });
        }
    }

    returnToOrder() {
        this.showCategories = true;
        this._profileCategoriesService.customerCategories.forEach(category => {
            if (category.description === 'ALL ITEMS') {
                category.selected = true;
                this._profileCategoriesService.selectedCategory = category;
            } else {
                category.selected = false;
            }
        });
        this.isCartEnabled = false;
        this._profileCategoriesService.selectedCategory.selected = true;

        const items = this.checkIfExists(this.orderItems);
        this.gridData = process(items, this.state);
        this.searchableItems = items;

        this._categoryChangeListener = true;
        this.restartState();
        this.gridData.total = this.searchableItems.length;

        this.categoryChanged();
        this._submitOrderButtonHidden = true;
        this._reviewOrderButtonHidden = false;
        this._returnToOrderButtonHidden = true;
        this._cancelOrderButtonHidden = false;
        this._copyOrderButtonHidden = false;
        this._lastQtyOrderButtonHidden = false;
    }

    private StartOrderTimerDB(timerAutoSavedb: number) {
        this.dbTimer = timer(0, timerAutoSavedb).subscribe(() => {
            if (!this.status) {
                return;
            }
            if (this._processRunning) {
                return;
            }
            if (this.hasValueChanged) {
                const itemQty = this.orderItems.filter(item => item.quantity > 0);
                if (itemQty.length > 0) {
                    this.saveOrder().catch();
                }
            }
        });
    }

    private showNotification(content: string, timeout: number) {
        this._toaster.info(content, '', {timeOut: timeout});
    }

    private showNotificationWarning(content: string, timeout: number) {
        this._toaster.warning(content, '', {timeOut: timeout});
    }
}
